import React from 'react'
import PropTypes from 'prop-types'
import { gridColumnsClass, gridColumnBgColor } from '../../helpers/gridUtils'
import ReferenceComponentRenderer from '../ReferenceComponentRenderer'

function ContentfulGrid({ data, componentExtraInformation }) {
  const { columnContent, columnNumber, backgroundColor } = data

  const columnItem = columnContent.map(content => {
    const contentType = content.__typename
    return (
      <div className="grid-column-content" key={content.id}>
        <ReferenceComponentRenderer
          contentType={contentType}
          node={content}
          insideRichText={false}
          componentExtraInformation={componentExtraInformation}
        />
      </div>
    )
  })
  return (
    <div className={gridColumnBgColor(backgroundColor)}>
      <section className={`container__inner column-spacing ${gridColumnsClass(columnNumber)}`}>
        {columnItem}
      </section>
    </div>
  )
}

ContentfulGrid.defaultProps = {
  componentExtraInformation: undefined
}

ContentfulGrid.propTypes = {
  data: PropTypes.object.isRequired,
  componentExtraInformation: PropTypes.object
}

export { query as data } from './gridQuery'

export default ContentfulGrid
